import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(relativeTime);
dayjs.extend(utc);

/**
 * Convert date to "x time ago"
 */
export const convertDateToFromNow = (date) => {
  if (!date) return "";
  return dayjs.utc(date).fromNow();
};

export default dayjs;
